import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const BusinessGlossaryTrainingV2: React.FC = () => {
  return (
    <TrainingShell
      moduleId="business-glossary"
      moduleName="E-Unify Business Glossary Training"
      backUrl="/learn"
    />
  );
};

export default BusinessGlossaryTrainingV2;
